import { Component } from 'react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import i18n from 'i18n';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
    this.handleRetry = this.handleRetry.bind(this);
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  handleRetry() {
    this.setState({ error: null });
  }

  render() {
    if (this.state.error) {
      return (
        <Box sx={{ p: 3 }}>
          <Alert severity="error">
            <Stack spacing={1.5}>
              <Typography variant="subtitle1">{i18n.t('errors.pageLoadTitle')}</Typography>
              <Typography variant="body2">{i18n.t('errors.pageLoadBody')}</Typography>
              <Button variant="outlined" size="small" onClick={this.handleRetry} sx={{ alignSelf: 'flex-start' }}>
                {i18n.t('emission.retry')}
              </Button>
            </Stack>
          </Alert>
        </Box>
      );
    }

    return this.props.children;
  }
}
